import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b9bb342"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "object-number"
}
const _hoisted_2 = {
  key: 1,
  class: "object-number"
}
const _hoisted_3 = {
  key: 0,
  class: "area-process"
}
const _hoisted_4 = { class: "process-header" }
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "trail" }
const _hoisted_8 = { class: "data-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "処理結果", -1))
const _hoisted_10 = {
  key: 0,
  class: "label-process-status processing"
}
const _hoisted_11 = {
  key: 1,
  class: "label-process-status complete"
}
const _hoisted_12 = {
  key: 2,
  class: "label-process-status refusal"
}
const _hoisted_13 = ["onClick", "onKeydown"]
const _hoisted_14 = ["onClick", "onKeydown"]
const _hoisted_15 = {
  key: 0,
  class: "object-item-table"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "detail" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = ["onClick", "onKeydown", "disabled"]
const _hoisted_20 = { class: "object-status" }
const _hoisted_21 = {
  key: 0,
  class: "label success"
}
const _hoisted_22 = {
  key: 1,
  class: "label error"
}
const _hoisted_23 = { class: "properties" }
const _hoisted_24 = {
  class: "property-list",
  "data-cy": "property-list-pid"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "永続的識別子", -1))
const _hoisted_26 = {
  class: "property-list",
  "data-cy": "property-list-collection-date"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "収集", -1))
const _hoisted_28 = {
  class: "property-list",
  "data-cy": "property-list-author"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "著者", -1))
const _hoisted_30 = {
  class: "property-list",
  "data-cy": "property-list-provider"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "提供機関", -1))
const _hoisted_32 = {
  class: "property-list",
  "data-cy": "property-list-permission"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "閲覧できる場所", -1))
const _hoisted_34 = { class: "process-footer" }
const _hoisted_35 = { class: "data-list" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "処理開始", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "処理終了", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "処理ID", -1))
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-result" }, "一致する資料は見つかりませんでした。", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_PlaceholderImage = _resolveComponent("PlaceholderImage")!
  const _component_PageNavigation = _resolveComponent("PageNavigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.props.sendList?.data.length !== 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.props.sendList?.count) + " 件中 " + _toDisplayString((_ctx.props.sendList?.page - 1) * (_ctx.props.sendList?.perpage) + 1) + " - " + _toDisplayString((_ctx.props.sendList?.perpage * _ctx.props.sendList?.page < _ctx.props.sendList?.count) ? (_ctx.props.sendList?.perpage * _ctx.props.sendList?.page) : _ctx.props.sendList?.count) + " 件 ", 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, " 0 件 "))
    ]),
    (_ctx.props.sendList?.data.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.sendList?.data, (data, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "object-process shadow",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", null, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.router.push(`detail/${data.jobId}`)),
                    onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.router.push(`detail/${data.jobId}`)), ["prevent"]), ["space","enter"]),
                    class: "button-jobDetail"
                  }, [
                    _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.convertDate(data.collectionDate)) + "にした送信", 1)
                  ], 40, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("dl", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("dd", null, [
                      (_ctx.convertStatus(data.status) === '処理中')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_component_DssIcon, { icon: 'status-processing' }),
                            _createTextVNode(" " + _toDisplayString(_ctx.convertStatus(data.status)), 1)
                          ]))
                        : (_ctx.convertStatus(data.status) === '終了')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createVNode(_component_DssIcon, { icon: 'status-complete' }),
                              _createTextVNode(" " + _toDisplayString(_ctx.convertStatus(data.status)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _createVNode(_component_DssIcon, { icon: 'status-refusal' }),
                              _createTextVNode(" " + _toDisplayString(_ctx.convertStatus(data.status)), 1)
                            ]))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["object-item-table-header", { isOpen: data.displayFlag }])
              }, [
                (data.displayFlag)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (data.displayFlag = false),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (data.displayFlag = false), ["prevent"]), ["space","enter"])
                    }, [
                      _createVNode(_component_DssIcon, {
                        icon: 'select-arrow-up',
                        size: 'is-large',
                        label: "資料一覧を閉じる"
                      })
                    ], 40, _hoisted_13))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: ($event: any) => (data.displayFlag = true),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (data.displayFlag = true), ["prevent"]), ["space","enter"])
                    }, [
                      _createVNode(_component_DssIcon, {
                        icon: 'select-arrow',
                        size: 'is-large',
                        label: "資料一覧を開く"
                      })
                    ], 40, _hoisted_14)),
                _createElementVNode("span", null, _toDisplayString(data.sentItemList.length) + " 件の資料", 1)
              ], 2),
              (data.displayFlag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.sentItemList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "object-item",
                        key: index
                      }, [
                        (item.thumbnailValue)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: `data:image/jpeg;base64,${item.thumbnailValue}`,
                              alt: "サムネイル",
                              width: "80"
                            }, null, 8, _hoisted_16))
                          : (_openBlock(), _createBlock(_component_PlaceholderImage, {
                              key: 1,
                              type: 'book-close',
                              style: {"height":"60px","width":"90px"}
                            })),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.toItem(item.pid)),
                              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.toItem(item.pid)), ["prevent"]), ["space","enter"]),
                              class: _normalizeClass(["button-itemDetail", { activeLink: item.title, inactiveLink: !item.title }]),
                              disabled: !item.title
                            }, _toDisplayString(_ctx.convertNull(item.title)), 43, _hoisted_19),
                            _createElementVNode("span", _hoisted_20, [
                              (item.successFlag)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 登録成功 "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_22, " 登録失敗 "))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("dl", _hoisted_24, [
                              _hoisted_25,
                              _createElementVNode("dd", null, _toDisplayString(_ctx.convertNull(item.pid)), 1)
                            ]),
                            _createElementVNode("dl", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("dd", null, _toDisplayString(_ctx.formatJst(item.collectionDate)), 1)
                            ]),
                            _createElementVNode("dl", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("dd", null, _toDisplayString(_ctx.convertNull(item.author)), 1)
                            ]),
                            _createElementVNode("dl", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("dd", null, _toDisplayString(_ctx.convertNull(item.provider)), 1)
                            ]),
                            _createElementVNode("dl", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("dd", null, _toDisplayString(_ctx.convertNull(_ctx.convertPermission(item.permission, '10008'))), 1)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("dl", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.splitDate(data.startAt)), 1),
                  _hoisted_37,
                  _createElementVNode("dd", null, _toDisplayString(_ctx.splitDate(data.endAt)), 1),
                  _hoisted_38,
                  _createElementVNode("dd", null, _toDisplayString(data.jobId), 1)
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41)),
    (_ctx.props.sendList?.data.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createVNode(_component_PageNavigation, {
            modelValue: _ctx.pageNumber,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageNumber) = $event)),
            displayCount: 5,
            items: _ctx.pageNavigationIndex
          }, null, 8, ["modelValue", "items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}